import { Link } from 'react-router-dom';

interface CategoryCardProps {
  slug: string;
  name: string;
  description: string;
  icon: string;
  articleCount: number;
}

export default function CategoryCard({ slug, name, description, icon, articleCount }: CategoryCardProps) {
  return (
    <Link
      to={`/category/${slug}`}
      className="group block bg-background-50 border border-background-200/70 rounded-lg p-6 hover:border-primary-200 transition-all duration-300"
    >
      <div className="w-12 h-12 flex items-center justify-center rounded-md bg-primary-100 mb-4 group-hover:bg-primary-200 transition-colors">
        <i className={`${icon} text-xl text-primary-600`}></i>
      </div>
      <h3 className="text-lg font-semibold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors font-heading whitespace-nowrap">
        {name}
      </h3>
      <p className="text-sm text-foreground-500 leading-relaxed mb-3 line-clamp-2">
        {description}
      </p>
      <span className="text-xs text-foreground-400">{articleCount} 篇文章</span>
    </Link>
  );
}